module.exports = __webpack_public_path__ + "static/media/2.644e1b4c.png";